import React from 'react'
// hocs
import withAction from 'components/Modals/PlanItems/Action/withAction'
// view components
import DetailsSection from 'components/Modals/PlanItems/Action/MinimizedModal/components/DetailsSection/index'
// components
import { Tab } from '@mui/material'
import { Tabs, Scrollbar } from 'components/UI'
import { LoaderWithOverlay } from 'components/UI/Loader'
// views
import { SubHeader } from 'components/Modals/PlanItems/styles'
// types
import { LogEntityTypes } from 'types/graphql'
// context
import { ActionContext } from 'context/index'

const ActionDetails: React.FunctionComponent<any> = ({ entity }) => {
  const [tab, setTab] = React.useState(0)

  const { isLoading } = React.useContext<any>(ActionContext)

  const handleSetTab = (_, value) => setTab(value)

  return (
    <>
      <LoaderWithOverlay isLoading={isLoading} />
      {!isLoading && entity && (
        <>
          <SubHeader>
            <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
              <Tab label='Details' />
            </Tabs>
          </SubHeader>

          <Scrollbar>
            {tab === 0 && <DetailsSection entity={{ ...entity, entityType: LogEntityTypes.Action }} />}
          </Scrollbar>
        </>
      )}
    </>
  )
}

export default withAction(ActionDetails)
